import { render, staticRenderFns } from "./TypeNumber.vue?vue&type=template&id=bbd4e14e&scoped=true"
import script from "./TypeNumber.vue?vue&type=script&lang=js"
export * from "./TypeNumber.vue?vue&type=script&lang=js"
import style0 from "./TypeNumber.vue?vue&type=style&index=0&id=bbd4e14e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd4e14e",
  null
  
)

export default component.exports